import { styled } from '@mui/material';
import { Icon, IconButton } from 'core/common/ui/ui-kit';

export const ButtonMeuStyled = styled(IconButton)`
  width: 24px;
  min-width: 24px;
  height: 24px;
  margin-left: 32px;
  padding: 4px;
  color: ${({ theme }) => theme.palette.header.menu.color};
`;

export const IconStyled = styled(Icon)`
  width: 20px;
  height: 20px;
  fill: currentColor;
`;
